export * from "./IPersonalizationData";